var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Luggage",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-luggage","viewBox":"0 100 612 612"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M553.2 222.2H376.4v-29.4c0-16.5-12.9-29.4-29.4-29.4h-82c-16.5 0-29.4 12.9-29.4 29.4v29.4H58.8C25.8 222.2 0 247.9 0 281v282.7c0 33 25.7 58.8 58.8 58.8h494.5c33 0 58.8-25.7 58.8-58.8V280.9c-.1-33-25.8-58.7-58.9-58.7zm-294.3-29.4c0-3.7 2.4-6.1 6.1-6.1h82.6c3.7 0 6.1 2.4 6.1 6.1v29.4h-94.9v-29.4zM58.8 599.2c-20.2 0-35.5-15.3-35.5-35.5V280.9c0-20.2 15.3-35.5 35.5-35.5h70.4v129.7h-23.3v82.6h23.3v141.4l-70.4.1zm70.9-165.3v-35.5H153v35.5h-23.3zM153 599.2V457.8h23.3v-82.6H153V246.1h306v129.7h-23.3v82.6H459v141.4H153v-.6zm306-165.3v-35.5h23.3v35.5H459zm129.7 129.8c0 20.2-15.3 35.5-35.5 35.5h-71V457.8h23.3v-82.6h-23.3V246.1h70.4c20.2 0 35.5 15.3 35.5 35.5v282.1h.6z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/luggage.svg